<template>
    <div id="LmTextInputBuilderUi" class="row">
      <LmTextInput
        class="col-12 col-md-4"
        v-model="component.componentProps.value"
        @input="$emit('input', component)"
        label="value"
        placeholder="value"
      />
      <LmSelect
        class="col-12 col-md-4"
        v-model="component.componentProps.type"
        :options="{
          content: [{value: 'submit', text: 'Submit'}, {value: 'button', text: 'Button'}]
        }"
        label="type"
        @input="$emit('input', component)"
      />
      <LmSelect
        class="col-12 col-md-4"
        v-model="component.actions.click.type"
        :options="actionsOptions"
        label="Acción"
        @input="$emit('input', component)"
      />
      <LmTextInput
        v-if="component.actions.click.type === 'submit'"
        class="col-12 col-md-4"
        v-model="component.actions.click.arguments.path"
        @input="$emit('input', component)"
        label="submit Path"
        placeholder="/mi-endopind-para-procesar"
      />
      <LmTextInput
        v-if="component.actions.click.type === 'submit'"
        class="col-12 col-md-4"
        v-model="component.actions.click.arguments.pathUpdate"
        @input="$emit('input', component)"
        label="update Path"
        placeholder="/mi-endopind-update"
      />
      <LmSelect
        v-if="component.actions.click.type === 'delete'"
        class="col-12 col-md-4"
        v-model="component.actions.click.arguments.deleteMethod"
        :options="deleteTypeOptions"
        label="Tipo de borrado"
        @input="$emit('input', component)"
      />
      <LmTextInput
        v-if="component.actions.click.type === 'delete'"
        class="col-12 col-md-4"
        v-model="component.actions.click.arguments.pathDelete"
        @input="$emit('input', component)"
        label="Delete Path"
        placeholder="/mi-endopind-delete"
      />
      <LmTextInput
        class="col-12 col-md-4"
        v-model="component.class"
        @input="$emit('input', component)"
        label="Clases css"
      />
      <LmTextInput
        class="col-12 col-md-4"
        v-model="component.componentProps.icon"
        @input="$emit('input', component)"
        label="Icono"
        placeholder="Fontawesome icon"
      />
      <LmTextInput
        class="col-12 col-md-4"
        v-model="component.componentProps.buttonClass"
        @input="$emit('input', component)"
        label="buttonClass"
      />
      <div class="col-12" v-if="component.actions.click.arguments.deleteMethod === 'put'">
        <h5>Propiedad que se edita para el borrado lógico</h5>
        <div class="row">
          <LmTextInput
            class="col-12 col-md-5"
            v-model="component.actions.click.arguments.logicDeleteProperty"
            label="Propiedad"
            placeholder="Propiedad"
            @input="$emit('input', component)"
          />
          <LmSelect
            class="col-12 col-md-4"
            v-model="component.actions.click.arguments.logicDeleteValue"
            :options="{
              content: [
              {text: 'false', value: false},
              {text: 'true', value: true}
              ]
            }"
            label="Valor"
            @input="$emit('input', component)"
          />
        </div>
      </div>
      <div class="col-12">
        <h5>Parámetros personalizables</h5>
        <div
          v-for="(param, index) in params"
          :key="index"
          class="row align-items-center"
        >
          <LmTextInput
            :id="`property-${index}`"
            class="col-12 col-md-5"
            v-model="params[index].property"
            @input="onParamsChange"
            label="Propiedad"
            placeholder="Propiedad"
          />
          <LmTextInput
            :id="`value-${index}`"
            class="col-12 col-md-5"
            v-model="params[index].value"
            @input="onParamsChange"
            label="Valor"
            placeholder="Valor"
          />
          <font-awesome-icon
            :id="`trash-icon-${index}`"
            class="clickable mt-3 col-12 col-md-1"
            icon="trash"
            @click="removeParam(index)"
          />
        </div>
        <LmButton
          :id="`lm-button`"
          type="button"
          value="Agregar parámetro"
          @click.native="addParam"
        />
      </div>
      <LmConditionalBuilderUi
        v-if="isVisibleCondition"
        class="col-12"
        :leftValueToCompareOptions="leftValueToCompareOptions"
        :visibilityDependOnConditions="visibilityDependOnConditions"
        @changeVisibilityDependOnConditions="component.visibilityDependOnConditions = $event"
        @input="$emit('input', component)"
        />
      <LmConditionalByEditModeBuilderUi
        :component="component"
        @input="$emit('input', component)"
        />
    </div>
</template>

<script>
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmSelect from '@/components/form/elements/LmSelect'
import LmButton from '@/components/form/elements/LmButton'
import LmConditionalBuilderUi from '@/components/lmFormBuilderUi/LmConditionalBuilderUi'
import LmConditionalByEditModeBuilderUi from '@/components/lmFormBuilderUi/LmConditionalByEditModeBuilderUi'

export default {
  data () {
    return {
      component: {},
      params: [],
      actionsOptions: {
        content: [{
          value: 'submit',
          text: 'Guardar o Actualizar'
        }, {
          value: 'delete',
          text: 'Eliminar'
        }, {
          value: 'cancel',
          text: 'Cancelar'
        }]
      },
      deleteTypeOptions: {
        content: [{
          value: 'put',
          text: 'Lógico'
        }, {
          value: 'delete',
          text: 'Permanente'
        }]
      }
    }
  },
  components: {
    LmTextInput,
    LmSelect,
    LmButton,
    LmConditionalBuilderUi,
    LmConditionalByEditModeBuilderUi
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    },
    visibilityDependOnConditions: {
      type: Object,
      default: () => ({
        isActive: false,
        conditions: []
      })
    },
    leftValueToCompareOptions: {
      type: Object,
      default: () => ({
        disabledOption: '',
        content: []
      })
    },
    componentData: {
      type: Object,
      default: () => (
        {
          class: 'col-auto',
          componentName: 'LmButton',
          componentProps: {
            isVisible: true,
            type: 'submit',
            value: 'Submit',
            buttonClass: 'btn-primary'
          },
          actions: {
            click: {
              type: 'submit',
              arguments: {
                path: ''
              }
            }
          }
        }
      )
    }
  },
  methods: {
    addParam () {
      this.params.push({
        property: '',
        value: ''
      })
    },
    removeParam (index) {
      this.params.splice(index, 1)
      this.onParamsChange()
    },
    onParamsChange () {
      // Paso los parámetros personalizables a un objeto antes de emitirlo al componente padre
      // Nota: forma ideal para modificar reactivamente propiedades de un objeto
      const paramsObject = {}
      for (const param of this.params) {
        const value = isNaN(param.value) || param.value === '' ? param.value : Number(param.value)
        paramsObject[param.property] = value
      }
      this.component.actions.click.params = paramsObject
      this.$emit('input', this.component)
    }
  },
  created () {
    this.component = this.componentData

    // Paso los parámetros personalizables a un array para el componente
    if (this.component?.actions?.click?.params) {
      for (const param in this.component.actions.click.params) {
        this.params.push({
          property: param,
          value: this.component.actions.click.params[param]
        })
      }
    }
  }
}
</script>
